module.exports = __webpack_public_path__ + "img/products-shortcut.e1eebff2.svg";